import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';

export const nguoiDungService = {
    getDetail,
    getPersonalDetail,
    lockAccount,
    unlockAccount,
    createAccount,
    updateUserAccount,
    resetPassword,
};

async function getDetail(params, tableName){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.API_URL}/${tableName}/GetDetail`, requestOptions).then(response => common.handleResponse(response));
}

async function getPersonalDetail(params, tableName){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.API_URL}/${tableName}/GetPersonalInfo`, requestOptions).then(response => common.handleResponse(response));
}


async function lockAccount(item, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(item)
    };
    return await fetch(`${config.API_URL}/${tableName}/LockAccount`, requestOptions).then(response => common.handleResponse(response));
}

async function unlockAccount(item, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(item)
    };
    return await fetch(`${config.API_URL}/${tableName}/UnlockAccount`, requestOptions).then(response => common.handleResponse(response));
}

async function createAccount(item, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(item)
    };
    return await fetch(`${config.API_URL}/${tableName}/Register`, requestOptions).then(response => common.handleResponse(response));
}

async function updateUserAccount(item, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(item)
    };
    return await fetch(`${config.API_URL}/${tableName}/UpdateUserAccount`, requestOptions).then(response => common.handleResponse(response));
}


async function resetPassword(item, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(item)
    };
    return await fetch(`${config.API_URL}/${tableName}/ResetPassword`, requestOptions).then(response => common.handleResponse(response));
}


